import styled from 'styled-components';

export const LoggingOutStyles = styled.div`
  color: #fff;
  display: flex;
  justify-content: center;
  height: 100vh;
  align-items: center;
`;
